<div class="user-img-container" [ngStyle]="{'width': size, 'height': size}"
    [style.background]="getBackgroundColor"
    [style.border]="colorPalete == 'light' ? 'none' : 'none'"
    [attr.title]="title">

    @if(imgSrc) {
    <img [src]="imgSrc" [ngStyle]="{'width': size, 'height': size}">
    } @else {
    <span class="initials" [style.color]="getTextColor"
        [style.font-size]="fontSize">{{getInitials}}</span>
    }

</div>